import Button from "@components/core/Button";
import { storyblokEditable } from "@storyblok/react";
import { useCurrentUser } from "@hooks/use-current-user";
import Link from "@components/core/Link";

function LargeBannerV2({ blok }) {
  const user = useCurrentUser();
  const userGroup = user?.user_group || "visitor";

  if (!blok) return null;

  return (
    <section key={blok._uid} {...storyblokEditable(blok)} className="storyblok-home-section">
      <div className="position-relative">
        <div
          className="large-banner-image-desktop"
          style={{ backgroundImage: `url("${blok.background_image_desktop.filename}")` }}
        />
        <div
          className="large-banner-image-mobile"
          style={{ backgroundImage: `url("${blok.background_image_mobile.filename}")` }}
        />
        <section className={`large-banner-v2-text-container w-100 px-4 text-${blok.text_color}`}>
          <h1 className="large-banner-v2-title">{blok.title}</h1>
          <p className="large-banner-v2-subtitle">{blok.subtitle}</p>
          <div className="large-banner-v2-btn">
            <Link
              href={blok.link?.url}
              className="w-100"
            >
              <Button
                variant={blok.link_variant}
                style={{ width: "auto" }}
                userGroup={userGroup}
                trackingName="homeLargeBannerV2"
              >
                {blok.link_title}
              </Button>
            </Link>
          </div>

        </section>
      </div>
    </section>
  );
}

export default LargeBannerV2;
